// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2704":"8a0d76ed","3638":"aba10f8d","6619":"852db456","7915":"2e7394d6"}[chunkId] + ".chunk.css";
};